import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";

import { RootState } from "../../../globals";
import HttpManager from "../../../services/HttpManager";
import EquipoView from "./equipoView";
import { push } from "./push";
import { TelefonoPanel } from "./telefono/telefonoUI";
import VentasBarra from "./ventasBarra";
import { useAltoVisible } from "./altoVisible";
import "./sales.css";
import "./crm.css";

/**
 * WappTeam (Esteban, 2026-10-09): el chat interno del equipo (canales por área y mensajes directos) en su propia sección
 * del menú Mensajería, ruta /wappteam. Antes era la pestaña "Equipo" dentro de WappChat. Quién la ve lo decide la
 * sección 81; las llamadas siguen en /wappchat/_equipo* y aceptan cualquiera de las dos secciones.
 */
const WappTeamController: React.FC = () => {
	const navigate = useNavigate();
	// /wappteam?c=N abre esa conversación (al tocar un aviso de WappTeam en el celular).
	const http = HttpManager.getInstance();
	const sessionCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const legacyCampusKey: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const legacyCampusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const legacyCampus: any = legacyCampusKey && legacyCampusRef ? legacyCampusRef[legacyCampusKey] : null;
	const campusId: number | null = legacyCampus?.id ?? sessionCampus?.id ?? null;
	// Rutas que tiene en su menú: la pestaña WappChat solo sale a quien entra a WappChat.
	const menuRef: any = useSelector((state: RootState) => (state as any).menuRef?.value);
	const veWappChat = !!menuRef?.wappchat;
	// Las mismas pestañas que WappChat (Esteban, 2026-10-09: "cuando le das a WappTeam no se mira CRM").
	const veCrm = !!menuRef?.prospects;

	// Avisos al instante mientras WappTeam está abierto.
	useEffect(() => (campusId ? push.usar(campusId) : undefined), [campusId]);
	const [noLeidos, setNoLeidos] = useState<number>(0);
	useEffect(() => {
		if (!campusId) return;
		// Solo el primer número: después lo pone EquipoView con su propia lista (que ya se recarga con cada aviso "equipo";
		// antes esta pestaña pedía la lista entera otra vez por cada mensaje).
		http.prospectsService.equipoCanales(campusId).then((r) => setNoLeidos(r.data.noLeidos)).catch(() => null);
	}, [campusId]);

	// ?c=N abre esa conversación (desde una ventanita de abajo o un aviso).
	const [params] = useSearchParams();
	const pedido = Number(params.get("c")) || null;
	const pedidoHilo = Number(params.get("h")) || null;

	const raiz = useRef<HTMLDivElement>(null);
	useAltoVisible(raiz, campusId);
	// El auto-marcador (la misma píldora que en CRM y WappChat) abre a la persona en WappChat.
	const navRef = useRef(navigate);
	navRef.current = navigate;
	const abrirDesdeMarcador = useCallback((id: number) => navRef.current("/wappchat?id=" + id), []);

	return (
		<div className="crm" ref={raiz}>
			{veWappChat || veCrm ? (
				<VentasBarra activo="team" campusId={campusId} veCrm={veCrm} veWappchat={veWappChat} veWappteam nTeam={noLeidos}
					onCrm={() => navigate("/prospects")} onWappchat={() => navigate("/wappchat")} onWappteam={() => undefined}
					onAbrirMarcador={abrirDesdeMarcador} />
			) : null}
			<div className="crm-cuerpo">
				{!campusId ? <div className="ventas"><div className="ventas-vacio">Cargando…</div></div>
					: <EquipoView campusId={campusId} pedido={pedido} pedidoHilo={pedidoHilo} onNoLeidos={setNoLeidos} onAbrirCliente={(id) => navigate("/wappchat?id=" + id)} />}
			</div>
			{campusId && veCrm ? <TelefonoPanel campusId={campusId} onAbrir={(id) => navigate("/wappchat?id=" + id)} /> : null}
		</div>
	);
};

export default WappTeamController;
